import React from "react";
import { useNavigate } from "react-router-dom";
import { decodeToken } from "../../security/tokenUtils.js";
import { APP_JSON, URL_APP, URL_BKI } from "../../constants/URL.js";
import { crearCookie } from "../../utils/cookie.js";
import { AUTH_TOKEN } from "../../constants/constants.js";
import fetchData from "../../libs/client/httpClient.js";

function Authenticator() {
  const navigate = useNavigate();

  React.useEffect(() => {
    const login = async () => {
      console.log("Logging");

      const queryParams = new URLSearchParams(window.location.search);
      const vista = queryParams.get("vista");
      const vistaError = queryParams.get("vistaError");
      const token = queryParams.get("token");

      console.log(" vista:", vista);
      console.log(" vistaError:", vistaError);
      console.log(" token:", token);

      if (vistaError) {
        console.log("Navigating to error page");
        navigate(vistaError);
        return
      }

      if (vista & !token) {
        console.log("Navigating to vista");
        navigate(vista);
        return
      }

      if (!token) {
        console.error("Token not generated");
        navigate(URL_APP.ERROR);
        return
      }

      try {
        const { data, error } = await fetchData(URL_BKI.VALIDATE_TOKEN, {
          config: {
            headers: {
              "Content-Type": APP_JSON,
              Accept: APP_JSON,
              Authorization: `Bearer ${token}`,
            },
          },
        });

        if (data === false) {
          navigate(URL_APP.UNATHENTICATED);
          return;
        }

        if (error) {
          console.error(`Error al pedir el recurso. Error: ${error.message}`);
          navigate(URL_APP.ERROR);
          return;
        }
      } catch (error) {
        console.error("Failed to process token:", error);
        navigate(URL_APP.ERROR);
        return
      }

      try {
        const decodedJWT = decodeToken(token);
        const expirationTime = decodedJWT.exp;
        const expirationDateInMs = new Date(expirationTime * 1000);
        crearCookie(AUTH_TOKEN, token, expirationDateInMs);

        navigate(vista);
      } catch (error) {
        console.error("Failed to process token:", error);
        navigate(URL_APP.ERROR);
      }
    };

    login();
  }, []);

  return null;
}

export default Authenticator;
